<template>
    <div class="card plain">
        <div class="card-body">
            <el-table
                v-loading="loading"
                ref="multipleTable"
                :data="tableData"
                @sort-change="handleSortChange"
                @row-click="handleRowClick">
                <el-table-column
                    fixed
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column
                    fixed
                    width="150"
                    align="center"
                    sortable="custom"
                    prop="registered_at"
                    :label="$t( 'investment.registered_at')">
                    <template slot-scope="scope">{{ scope.row['registered_at'] }}</template>
                </el-table-column>
                <el-table-column
                    fixed
                    width="200"
                    align="center"
                    sortable="custom"
                    prop="project_name"
                    :label="$t( 'investment.project_name')">
                    <template slot-scope="scope">{{ scope.row['project_name'] }}</template>
                </el-table-column>
                <el-table-column
                    fixed
                    width="150"
                    align="right"
                    header-align="right"
                    prop="ammount_investment"
                    :label="$t( 'investment.ammount_investment')"
                >
                    <template slot-scope="scope">${{ scope.row['ammount_investment'] }}</template>
                </el-table-column>
                <el-table-column 
                    width="220"
                    v-for="(stage, s) in stages" :key="getStepKeyUUID(s)"
                    align="center"
                    :label="$t( 'investment.' + getLabelName(stage.name))">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status == stage.name" effect="dark" type="success"><i class="now-ui-icons el-icon-check"></i></el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                    width="350"
                    align="center"
                    prop="reference_payment"
                    :label="$t( 'investment.reference_payment')">
                    <template slot-scope="scope">
                        {{ scope.row['reference_payment'] }}
                    </template>
                </el-table-column>
                <el-table-column
                width="350"
                fixed="right"
                align="right">
                    <template slot="header" slot-scope="scope">
                        <el-input
                        v-model="search"
                        clearable @input="handleInputSearch"
                        placeholder="Referencia de pago"/>
                    </template>
                    <template slot-scope="scope">
                        <el-button @click="$router.push({ name: 'invest_detail', params: { id: scope.row.id }})">Ver</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="card-footer p-3 m4">
            <el-pagination
                @current-change="handleCurrentChange"
                :page-size="pagination.per_page"
                :page-count="pagination.current_page"
                layout="prev, pager, next, sizes"
                :total="pagination.total"
                @size-change="handleChangeSizePage"
                >
            </el-pagination>
        </div>
    </div>
</template>
<script>

import { Table, TableColumn, Pagination, Button, Input, Select, Option, MessageBox, Message, Drawer, Tag } from 'element-ui';
import _ from 'lodash'

import Investment from '@/providers/Investments'
import Settings from '@/providers/Settings'
const provider = new Investment()
const providerSettings = new Settings()

export default {
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Button.name]: Button,
        [Select.name]: Select,
        [Option.name]: Option,
        [Input.name]: Input,
        [Pagination.name]: Pagination,
        [Drawer.name]: Drawer,
        [Tag.name]: Tag
    },
    props: {
      filters: {
          String
      }
    },
    computed: {
        
    },
    mounted() {
        this.loadData()
        this.getStages()
    },
    data() {
      return {
        sortKey: null,
        tableData: [],
        multipleSelection: [],
        pagination: {
          current_page: 1,
          per_page: 10,
          total: 0
        },
        search: '',
        sort: `sort[${this.sortKey || 'id'}]=desc`,
        loading: false,
        stages: [],
        stageColors: [
            '',
            '',
            '',
            '',
            'success',
            '',
            '',
            'success',
            '',
            '',
            'danger',
            'sucess'
        ]
      }
    },
    methods: {
        loadData() {
            this.loading = true
            var filters = ''
            var inputSearch = _.clone(this.search)
            if(inputSearch){
                filters += 'f[ref]=' + inputSearch
            } else {
                filters += 'f[ref]='
            }

            provider.getInvestments(this.pagination.per_page, this.pagination.current_page, this.sort, filters).then((response) => {
                this.tableData = response.data.data
                this.pagination = response.data.meta.pagination
                this.loading = false
            }).catch((err) => {
                console.info('error data request')
                console.info(err)
                this.loading = false
            })
        },
        getStages() {
            let filter = "type=I"
            providerSettings.getData('stages', 50, 1, null, filter).then((response) => {
                let data = response.data.data
                this.stages = data
            }).catch((err) => {
                console.info('error get stages request')
                console.info(err)
            })
        },
        handleSortChange(sortConfig){
            let order = sortConfig.column.order == 'descending' ? 'desc' : 'asc'
            let prop = sortConfig.column.property
            this.sort = 'sort['+ prop + ']=' + order
            this.loadData()
        },
        handleCurrentChange(val) {
            this.pagination.current_page = val
            this.loadData()
        },
        handleInputSearch() {
            this.loadData()
        },
        handleChangeStep(proj) {
            
        },
        handleRowClick(row, column, event) {
            
        },
        handleChangeSizePage (val) {
            this.pagination.per_page = val
            this.loadData()
        },
        getStageColor(id){
            return this.stageColors[id - 1]
        },
        getStepKeyUUID (index) {
            return Math.random() + index
        },
        getLabelName(item) {
            let label = item.replace(' ', '')
            label = label.replace(' ', '')
            return label.toLowerCase()
        }
    },
    watch: {
        selectAll() {
            if(!_.isEmpty(this.dataArray)) {
                _.each(this.dataArray, (v)=> {
                v.selected = this.selectAll
                })
                this.showMenuValue = this.selectAll
            }
        }
    }
};
</script>
<style>
.el-select .el-input {
    width: 110px;
}
.input-with-select .el-input-group__prepend {
    background-color: #fff;
}

.el-table__row {
    cursor:pointer;
}
</style>
